import { Box, styled } from "@mui/material";

export const GetPasswordButtonWrapper = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  "&  .MuiBox-root": {
    flexBasis: "501px",
  },
}));

export const StyledForgotPasswordBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(5),
  [theme.breakpoints.down("sm")]: {
    marginTop: theme.spacing(3),
  },
}));


